import { createContext, useContext } from 'react';

/**
 * Published by FormFieldsRenderer with the column count the CSS grid is actually
 * using (post-solver, post-gear-shift). Consumed by FormEachInlineRenderer so its
 * internal MatrixFieldsRoot uses the SAME column count as the fields above/below it.
 *
 * This is the single source of truth for "how wide is the current grid?".
 * No consumer should compute this independently from orch.json values.
 */
export const MatrixColumnCountContext = createContext<number>(4);

export function useMatrixColumnCount(): number {
  return useContext(MatrixColumnCountContext);
}
